import { api } from "@/lib/api";

export const SUBMISSION_FILE_ACCEPT = ".jpg,.jpeg,.png,.heic,.heif,.pdf,.docx,.xlsx,image/jpeg,image/png,image/heic,image/heif,application/pdf";
const ALLOWED = ["jpg", "jpeg", "png", "heic", "heif", "pdf", "docx", "xlsx"];
const MAX_BYTES = 10 * 1024 * 1024;

export function submissionFileError(file) {
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (!ALLOWED.includes(extension)) return `${file.name}: unsupported file type`;
  if (file.size > MAX_BYTES) return `${file.name}: file must be 10 MB or smaller`;
  if (!file.size) return `${file.name}: file is empty`;
  return "";
}

export async function uploadSubmissionFiles(assignmentId, files, onProgress) {
  const form = new FormData();
  files.forEach((file) => form.append("files", file));
  return api.post(`/assignments/${assignmentId}/submission/files`, form, {
    onUploadProgress: (event) => {
      const total = event.total || 0;
      onProgress?.(total ? Math.round((event.loaded / total) * 100) : 0);
    },
  });
}

export function validWorkLink(value) {
  if (!value?.trim()) return false;
  try {
    const parsed = new URL(value.trim());
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
}